// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__JAOBQ"};